import React, { Component } from "react";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css"; // Import DatePicker CSS
import {
    tokens,
    select_style,
    // alert
    alert,
    // function
    format_date,
    toFixed,
    // api
    GET,
    // storage
    getStorage,
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

import { utils as XLSXUtils, write as XLSXWrite } from 'xlsx';
import { saveAs } from 'file-saver';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

// Initialize pdfMake fonts
pdfMake.vfs = pdfFonts.pdfMake.vfs;

// Thai font registration (make sure these font files are available in your project)
pdfMake.fonts = {
    THSarabunNew: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew-Bold.ttf',
        italics: 'THSarabunNew-Italic.ttf',
        bolditalics: 'THSarabunNew-BoldItalic.ttf'
    }
};

// Custom DatePicker component with icon
const CustomDatePicker = ({ selected, onChange, placeholderText, minDate, maxDate }) => {
    return (
        <div className="position-relative">
            <DatePicker
                className="form-control"
                selected={selected}
                onChange={onChange}
                dateFormat="dd/MM/yyyy"
                placeholderText={placeholderText}
                minDate={minDate}
                maxDate={maxDate}
                isClearable
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
            />
            <div className="position-absolute" style={{ right: "10px", top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}>
                <span className="icon text-muted">{"\uf133"}</span> {/* Calendar icon */}
            </div>
        </div>
    );
};

export default class ReceiptReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data: [],
            data_supplier: [],
            selected_company: null,
            searchText: "",
            startDate: new Date(), // Set current date as default
            endDate: new Date(), // Set current date as default
            exportLoading: false
        }
    }

    async componentDidMount() {
        this.setState({ loading: true });
        await this.GetSupplier();
        await this.GetReceiptList();
        this.setState({ loading: false });
    }

    GetSupplier = async () => {
        let body = {
            page: 0,
            data_search: "",
            company_type: 2,
            company_id: ""
        }
        let result = await GET(tokens, "v1/TH/company-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            this.setState({ 
                data_supplier: result.data.map(e => { 
                    return { 
                        value: e.company_id, 
                        label: e.company_name, 
                        tax_number: e.tax_number, 
                        address: e.address 
                    } 
                }) 
            });
        }
    }

    GetReceiptList = async () => {
        this.setState({ loading: true });

        // Format dates for API request
        const startDate = this.state.startDate ? format_date(this.state.startDate, "yyyy-mm-dd", "en") : "";
        const endDate = this.state.endDate ? format_date(this.state.endDate, "yyyy-mm-dd", "en") : "";
        
        let body = {
            page: 0,
            decision_status: 1,
            data_search: this.state.searchText,
            company_id: this.state.selected_company ? this.state.selected_company.value : "",
            start_date: startDate,
            end_date: endDate
        }

        let result = await GET(tokens, "v1/TH/goods-receipt/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            // Get full details for each receipt
            const detailedData = [];
            for (const item of result.data) {
                const detailBody = {
                    page: "",
                    data_search: "",
                    g_rec_main_id: item.g_rec_main_id
                }
                const detailResult = await GET(tokens, "v1/TH/goods-receipt/list/" + getStorage("branch").branch_id, detailBody);
                if (detailResult && detailResult.status) {
                    detailedData.push(detailResult.data);
                }
            }
            this.setState({ data: detailedData });
        }
        this.setState({ loading: false });
    }

    handleSearch = () => {
        this.GetReceiptList();
    }

    handleCompanyChange = (selected) => {
        this.setState({ selected_company: selected });
    }

    handleStartDateChange = (date) => {
        this.setState({ startDate: date });
    }

    handleEndDateChange = (date) => {
        this.setState({ endDate: date });
    }

    handleSearchTextChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    // Add this method to your component
    exportToExcel = async () => {
        this.setState({ exportLoading: true });
        
        try {
            const { data } = this.state;
            const workbook = XLSXUtils.book_new();
            
            // Create a single array to hold all rows
            const allReceiptsRows = [];
            
            // Add title row
            allReceiptsRows.push(['รายงานการรับสินค้าแสดงแบบละเอียด']);
            allReceiptsRows.push([]);  // Empty row for spacing
            
            // For each receipt, add its data to the combined array
            data.forEach((receipt, index) => {
                // Add separator between receipts (except for the first one)
                if (index > 0) {
                    allReceiptsRows.push([]);  // Empty row for spacing
                    allReceiptsRows.push(['----------------------------------------------------------------------------------------------------------']);
                    allReceiptsRows.push([]);  // Empty row for spacing
                }
                
                // Create header row data
                allReceiptsRows.push(['เลขที่ใบรับสินค้า:', receipt.bill_receipt_code || '-', '', 'วันที่รับสินค้า:', receipt.receive_date || '-']);
                allReceiptsRows.push(['ชื่อบริษัทคู่ค้า:', receipt.relation_company_supplier ? receipt.relation_company_supplier.company_name : '-', '', '', '']);
                allReceiptsRows.push([]);  // Empty row for spacing
                
                // Add column headers
                allReceiptsRows.push(['ลำดับ', 'รหัสสินค้า', 'รายการ', 'serial number', 'จำนวน', 'ราคา/หน่วย', 'ราคารวม']);
                
                // Add product rows data
                if (receipt.goods_receipt_list && receipt.goods_receipt_list.length > 0) {
                    receipt.goods_receipt_list.forEach((item, itemIndex) => {
                        // Add main product row
                        allReceiptsRows.push([
                            itemIndex + 1,
                            item.relation_product_main ? item.relation_product_main.product_code : '-',
                            item.relation_product_main ? item.relation_product_main.product_name : '-',
                            item.serial_numbers && item.serial_numbers.length > 0 ? item.serial_numbers[0] : '-',
                            item.quantity,
                            item.price_by_item,
                            item.total_price_by_item
                        ]);
                        
                        // Add additional serial numbers as separate rows if available
                        if (item.serial_numbers && item.serial_numbers.length > 1) {
                            item.serial_numbers.slice(1).forEach(serial => {
                                allReceiptsRows.push(['', '', '', serial, '', '', '']);
                            });
                        }
                    });
                } else {
                    // No items case
                    allReceiptsRows.push(['ไม่พบรายการสินค้า', '', '', '', '', '']);
                }
                
                // Add summary rows
                allReceiptsRows.push([]);  // Empty row for spacing
                allReceiptsRows.push(['รวมเป็นเงิน:', receipt.total_price, '', 'ส่วนลด:', receipt.discount]);
                allReceiptsRows.push(['ราคาหลังหักส่วนลด:', receipt.total_price - receipt.discount, '', 'ภาษีมูลค่าเพิ่ม 7%:', receipt.vat]);
                allReceiptsRows.push(['จำนวนเงินรวมทั้งสิ้น:', receipt.total_price_final, '', '', '']);
            });
            
            // Create a single worksheet with all the combined data
            const ws = XLSXUtils.aoa_to_sheet(allReceiptsRows);
            
            // Set column widths for better readability
            const colWidths = [
                { wch: 15 },  // ลำดับ/รวมเป็นเงิน
                { wch: 10 },  // รายการ/ค่า
                { wch: 40 },  // รายการ/ค่า
                { wch: 20 },  // serial number
                { wch: 15 },  // จำนวน/ส่วนลด
                { wch: 15 },  // ราคา/หน่วย/ค่า
                { wch: 15 }   // ราคารวม
            ];
            
            ws['!cols'] = colWidths;
            
            // Add some basic styling (title is merged across cells)
            if (!ws['!merges']) ws['!merges'] = [];
            ws['!merges'].push({ s: { r: 0, c: 0 }, e: { r: 0, c: 5 } }); // Merge first row across all columns for title
            
            // Add worksheet to workbook
            XLSXUtils.book_append_sheet(workbook, ws, "รายงานการรับสินค้า");
            
            // Generate Excel file
            const excelBuffer = XLSXWrite(workbook, { bookType: 'xlsx', type: 'array' });
            
            // Create Blob and download
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            
            // Generate file name with current date
            const dateStr = new Date().toISOString().slice(0, 10);
            const fileName = `รายงานการรับสินค้า_${dateStr}.xlsx`;
            
            saveAs(blob, fileName);
            
            alert("success", "แจ้งเตือน", "ดาวน์โหลดรายงาน Excel สำเร็จ");
        } catch (error) {
            console.error("Export to Excel error:", error);
            alert("error", "แจ้งเตือน", "เกิดข้อผิดพลาดในการดาวน์โหลดรายงาน Excel");
        } finally {
            this.setState({ exportLoading: false });
        }
    }

    exportToPDF = async () => {
        this.setState({ exportLoading: true });
        
        try {
            const { data } = this.state;
            
            if (!data || data.length === 0) {
                throw new Error("No receipt data available");
            }
            
            // Create content for PDF
            const documentContent = [];
            
            // Add title
            documentContent.push(
                { text: "รายงานการรับสินค้าแสดงแบบละเอียด", alignment: "center", fontSize: 20, bold: true, margin: [0, 0, 0, 15] }
            );
            
            // For each receipt, create a table structure
            data.forEach((receipt, index) => {
                // Add spacing between receipts except for the first one
                if (index > 0) {
                    documentContent.push({ text: "", margin: [0, 20, 0, 5] });
                }
                
                // Receipt header table
                const headerTable = {
                    table: {
                        widths: ['15%', '55%', '30%'],
                        body: [
                            [
                                { text: 'เลขที่ใบรับสินค้า', alignment: 'center', fillColor: '#007bff', color: 'white', bold: true },
                                { text: 'ชื่อบริษัทคู่ค้า', alignment: 'center', fillColor: '#007bff', color: 'white', bold: true },
                                { text: 'วันที่รับสินค้า', alignment: 'center', fillColor: '#007bff', color: 'white', bold: true }
                            ],
                            [
                                { text: receipt.bill_receipt_code || '-', alignment: 'center' },
                                { text: receipt.relation_company_supplier ? receipt.relation_company_supplier.company_name : "-", alignment: 'left' },
                                { text: format_date(receipt.receive_date, "dd/mm/yyyy", "th") || '-', alignment: 'center' }
                            ]
                        ]
                    },
                    layout: 'lightHorizontalLines',
                    margin: [0, 0, 0, 5]
                };
                
                documentContent.push(headerTable);
                
                // Receipt items table
                const itemsTableBody = [
                    [
                        { text: 'ลำดับ', alignment: 'center', fillColor: '#f8f9fa', bold: true },
                        { text: 'รหัสสินค้า', alignment: 'left', fillColor: '#f8f9fa', bold: true },
                        { text: 'รายการ', alignment: 'left', fillColor: '#f8f9fa', bold: true },
                        { text: 'serial number', alignment: 'center', fillColor: '#f8f9fa', bold: true },
                        { text: 'จำนวน', alignment: 'center', fillColor: '#f8f9fa', bold: true },
                        { text: 'ราคา/หน่วย', alignment: 'center', fillColor: '#f8f9fa', bold: true },
                        { text: 'ราคารวม', alignment: 'center', fillColor: '#f8f9fa', bold: true }
                    ]
                ];
                
                // Add items to table
                if (receipt.goods_receipt_list && receipt.goods_receipt_list.length > 0) {
                    receipt.goods_receipt_list.forEach((item, itemIndex) => {
                        // Add main product row
                        itemsTableBody.push([
                            { text: (itemIndex + 1).toString(), alignment: 'center' },
                            { text: item.relation_product_main.product_code, alignment: 'left' },
                            { text: item.relation_product_main ? item.relation_product_main.product_name : "-", alignment: 'left' },
                            { text: item.serial_numbers && item.serial_numbers.length > 0 ? item.serial_numbers[0] : "-", alignment: 'center' },
                            { text: item.quantity.toString(), alignment: 'center' },
                            { text: toFixed(item.price_by_item), alignment: 'right' },
                            { text: toFixed(item.total_price_by_item), alignment: 'right' }
                        ]);
                        
                        // Add additional serial numbers as separate rows if available
                        if (item.serial_numbers && item.serial_numbers.length > 1) {
                            item.serial_numbers.slice(1).forEach(serial => {
                                itemsTableBody.push([
                                    { text: '', alignment: 'center' },
                                    { text: '', alignment: 'center' },
                                    { text: '', alignment: 'left', margin: [15, 0, 0, 0] },
                                    { text: serial, alignment: 'center' },
                                    { text: '', alignment: 'center' },
                                    { text: '', alignment: 'right' },
                                    { text: '', alignment: 'right' }
                                ]);
                            });
                        }
                    });
                } else {
                    // No items case
                    itemsTableBody.push([
                        { text: 'ไม่พบรายการสินค้า', colSpan: 7, alignment: 'center' },
                        {}, {}, {}, {}, {}, {}
                    ]);
                }
                
                const itemsTable = {
                    table: {
                        widths: ['8%', '12%', '28%', '12%', '10%', '15%', '15%'],
                        body: itemsTableBody
                    },
                    layout: 'lightHorizontalLines',
                    margin: [0, 0, 0, 0]
                };
                
                documentContent.push(itemsTable);
                
                // Receipt summary
                const summaryRow = {
                    columns: [
                        { text: 'รวมเป็นเงิน: ' + toFixed(receipt.total_price), width: 'auto', margin: [0, 0, 15, 0] },
                        { text: 'ส่วนลด: ' + toFixed(receipt.discount), width: 'auto', margin: [0, 0, 15, 0] },
                        { text: 'ราคาหลังหักส่วนลด: ' + toFixed(receipt.total_price - receipt.discount), width: 'auto', margin: [0, 0, 15, 0] },
                        { text: 'ภาษีมูลค่าเพิ่ม 7%: ' + toFixed(receipt.vat), width: 'auto', margin: [0, 0, 15, 0] },
                        { text: 'จำนวนเงินรวมทั้งสิ้น: ' + toFixed(receipt.total_price_final), width: 'auto' }
                    ]
                };
                
                const summaryTable = {
                    table: {
                        widths: ['*'],
                        body: [[{ 
                            ...summaryRow, 
                            fillColor: '#f8f9fa'
                        }]]
                    },
                    layout: {
                        hLineWidth: function(i, node) { return 1; },
                        vLineWidth: function(i, node) { return 1; },
                        hLineColor: function(i, node) { return '#dddddd'; },
                        vLineColor: function(i, node) { return '#dddddd'; }
                    },
                    margin: [0, 5, 0, 0]
                };
                
                documentContent.push(summaryTable);
            });
            
            // Generate date for filename
            const dateStr = new Date().toISOString().slice(0, 10);
            const fileName = `รายงานการรับสินค้า_${dateStr}.pdf`;
            
            // Define the document
            const documentDefinition = {
                content: documentContent,
                defaultStyle: {
                    font: 'THSarabunNew',
                    fontSize: 16
                },
                pageSize: 'A4',
                pageMargins: [20, 20, 20, 20]
            };
            
            // Generate and download the PDF
            pdfMake.createPdf(documentDefinition).download(fileName);
            
            alert("success", "แจ้งเตือน", "ดาวน์โหลดรายงาน PDF สำเร็จ");
        } catch (error) {
            console.error("Export to PDF error:", error);
            alert("error", "แจ้งเตือน", "เกิดข้อผิดพลาดในการดาวน์โหลดรายงาน PDF");
        } finally {
            this.setState({ exportLoading: false });
        }
    }

    render() {
        const { data } = this.state;
        
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="รายงานการรับสินค้า" />
                
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex mx-0 align-items-center justify-content-between test mb-2 flex-wrap">
                            <h3 className="mb-2"><b>รายงานการรับสินค้าแสดงแบบละเอียด</b></h3>
                            <div>
                                <button 
                                    className="btn btn-success mx-1" 
                                    onClick={this.exportToExcel}
                                    disabled={this.state.exportLoading}>
                                    <span className="icon me-2">{"\uf1c3"}</span>Excel
                                </button>
                                <button 
                                    className="btn btn-danger mx-1" 
                                    onClick={this.exportToPDF}
                                    disabled={this.state.exportLoading}>
                                    <span className="icon me-2">{"\uf1c1"}</span>PDF
                                </button>
                            </div>
                        </div>

                        {/* Search Filters */}
                        <div className="w-100 card border-0 p-3 rounded-lg mb-3">
                            <div className="row">
                                <div className="col-12 col-md-3 mb-2">
                                    <label className="mb-2">ค้นหา:</label>
                                    <div className="input-group">
                                        <input
                                            className="form-control"
                                            type="text"
                                            placeholder="ค้นหาเลขที่ใบรับ หรือ ชื่อบริษัท"
                                            onChange={this.handleSearchTextChange}
                                            value={this.state.searchText}
                                        />
                                        <span className="input-group-text bg-white">
                                            <span className="icon text-muted">{"\uf002"}</span>
                                        </span>
                                    </div>
                                </div>
                                <div className="col-12 col-md-3 mb-2">
                                    <label className="mb-2">บริษัทคู่ค้า:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_supplier}
                                        onChange={this.handleCompanyChange}
                                        value={this.state.selected_company}
                                        placeholder="เลือกบริษัท"
                                        isClearable
                                    />
                                </div>
                                <div className="col-12 col-md-2 mb-2">
                                    <label className="mb-2">วันที่เริ่มต้น:</label>
                                    <CustomDatePicker
                                        selected={this.state.startDate}
                                        onChange={this.handleStartDateChange}
                                        placeholderText="เลือกวันที่เริ่มต้น"
                                        maxDate={this.state.endDate}
                                    />
                                </div>
                                <div className="col-12 col-md-2 mb-2">
                                    <label className="mb-2">วันที่สิ้นสุด:</label>
                                    <CustomDatePicker
                                        selected={this.state.endDate}
                                        onChange={this.handleEndDateChange}
                                        placeholderText="เลือกวันที่สิ้นสุด"
                                        minDate={this.state.startDate}
                                    />
                                </div>
                                <div className="col-12 col-md-2 mb-2 d-flex align-items-end">
                                    <button 
                                        className="btn btn-primary w-100" 
                                        onClick={this.handleSearch}>
                                        <span className="icon me-2">{"\uf002"}</span>ค้นหา
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Receipt Report in Detail View */}
                        <div className="card border rounded-lg p-3 mb-3">
                            {data.length > 0 ? (
                                data.map((receipt, index) => (
                                    <div key={index}>
                                        {/* Receipt Header */}
                                        <div className="row">
                                            <div className="col-md-12">
                                                <table className="table table-bordered bg-light mb-0">
                                                    <tbody>
                                                        {index === 0 && (
                                                            <tr className="bg-primary text-white">
                                                                <th className="text-center" style={{width: "15%"}}><b>เลขที่ใบรับสินค้า</b></th>
                                                                <th className="text-center" style={{width: "55%"}}><b>ชื่อบริษัทคู่ค้า</b></th>
                                                                <th className="text-center" style={{width: "30%"}}><b>วันที่รับสินค้า</b></th>
                                                            </tr>
                                                        )}
                                                        <tr>
                                                            <td className="text-center">{receipt.bill_receipt_code}</td>
                                                            <td>{receipt.relation_company_supplier ? receipt.relation_company_supplier.company_name : "-"}</td>
                                                            <td className="text-center">{format_date(receipt.receive_date, "dd/mm/yyyy", "th")}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Receipt Detail */}
                                        <div className="row mt-0">
                                            <div className="col-md-12">
                                                <table className="table table-bordered mb-0">
                                                    <thead>
                                                        <tr className="bg-light">
                                                            <th className="text-center" style={{width: "5%"}}><b>ลำดับ</b></th>
                                                            <th className="text-left" style={{width: "10%"}}><b>รหัสสินค้า</b></th>
                                                            <th className="text-left" style={{width: "35%"}}><b>รายการ</b></th>
                                                            <th className="text-center" style={{width: "15%"}}>serial<b> number</b></th>
                                                            <th className="text-center" style={{width: "10%"}}><b>จำนวน</b></th>
                                                            <th className="text-center" style={{width: "12.5%"}}>ราคา/หน่วย<b></b></th>
                                                            <th className="text-center" style={{width: "12.5%"}}><b>ราคารวม</b></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {receipt.goods_receipt_list && receipt.goods_receipt_list.map((item, itemIndex) => (
                                                            <React.Fragment key={itemIndex}>
                                                                <tr>
                                                                    <td className="text-center">{itemIndex + 1}</td>
                                                                    <td>{item.relation_product_main.product_code}</td>
                                                                    <td>{item.relation_product_main ? item.relation_product_main.product_name : "-"}</td>
                                                                    <td className="text-center">
                                                                        {item.serial_numbers && item.serial_numbers.length > 0 
                                                                            ? item.serial_numbers[0] 
                                                                            : "-"}
                                                                    </td>
                                                                    <td className="text-center">{item.quantity}</td>
                                                                    <td className="text-end">{toFixed(item.price_by_item)}</td>
                                                                    <td className="text-end">{toFixed(item.total_price_by_item)}</td>
                                                                </tr>
                                                                {item.serial_numbers && item.serial_numbers.length > 1 && 
                                                                    item.serial_numbers.slice(1).map((serial, serialIndex) => (
                                                                        <tr key={`${itemIndex}-${serialIndex}`}>
                                                                            <td></td>
                                                                            <td className="ps-5"></td>
                                                                            <td className="text-center">{serial}</td>
                                                                            <td colSpan="3"></td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </React.Fragment>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Receipt Summary */}
                                        <div className="row mt-0">
                                            <div className="col-md-12 mb-0">
                                                <div className="p-2 border border-dark  d-flex justify-content-between bg-light">
                                                    <span><strong>รวมเป็นเงิน</strong> {toFixed(receipt.total_price)}</span>
                                                    <span><strong>ส่วนลด</strong> {toFixed(receipt.discount)}</span>
                                                    <span><strong>ราคาหลังหักส่วนลด</strong> {toFixed(receipt.total_price - receipt.discount)}</span>
                                                    <span><strong>ภาษีมูลค่าเพิ่ม 7%</strong> {toFixed(receipt.vat)}</span>
                                                    <span><strong>จำนวนเงินรวมทั้งสิ้น</strong> {toFixed(receipt.total_price_final)}</span>
                                                </div>
                                                <div className="p-2 d-flex justify-content-between ">
                                                    <span><strong></strong></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="text-center py-5">
                                    <h5>ไม่พบข้อมูลใบรับสินค้า</h5>
                                    <p>กรุณาปรับเงื่อนไขการค้นหาใหม่</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

// Add this CSS to your global CSS file or include it inline
/*
.react-datepicker-wrapper {
  display: block;
  width: 100%;
}

.react-datepicker__input-container input {
  width: 100%;
  height: 38px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.react-datepicker__input-container input:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.react-datepicker {
  font-family: inherit;
  border-radius: 0.3rem;
  border: 1px solid #ddd;
}

.react-datepicker__triangle {
  display: none;
}

.react-datepicker__header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #ddd;
}

.react-datepicker__day--selected {
  background-color: #007bff;
}

.react-datepicker__day--keyboard-selected {
  background-color: rgba(0, 123, 255, 0.5);
}

.react-datepicker__day:hover {
  background-color: #e9ecef;
}

.react-datepicker__day--selected:hover {
  background-color: #0069d9;
}
*/